export const SET_PASSWORD_VISIBILITY = 'SET_PASSWORD_VISIBILITY';
export const CLEAR_STATE_FORM = 'CLEAR_STATE_FORM';